import React, { Component } from 'react';
import { obtenirMenu, obtenirServiceGarde, obtenirSanctions, obtenirDelai } from '../../services/PSP.service';
import { Chargement } from './Chargement';
import { Erreur } from './Erreur';
import { InformationSG } from './InformationSG';
import { Menu } from './Menu';
import { Resultat } from './Resultat';
import { Sanctions } from './Sanctions';

export class Presentation extends Component {
    estMonte = false;

    constructor(props) {
        super(props)
        this.state = {
            serviceGarde: null,
            menus: null,
            sanctions: null,
            enChargementServiceGarde: true,
            enChargementMenu: true,
            enChargementDelai: true,
            enChargementSanctions: true,
            afficherSantions: false,
        }
    }

    componentDidMount() {
        let element = document.getElementsByClassName('droits')[0];
        element.innerHTML = element.innerHTML.replace('2020', '2023');

        this.estMonte = true;
        obtenirServiceGarde().then(reponse => {
            const serviceGarde = reponse;

            if (!serviceGarde.erreur) {
                obtenirMenu().then(reponse => {
                    const menus = reponse;

                    if (this.estMonte) {
                        this.setState({ menus: menus, enChargementMenu: false });
                    }
                });

                obtenirDelai().then(reponse => {
                    const delai = reponse;

                    if (this.estMonte) {
                        this.setState({ delai: delai, enChargementDelai: false });
                    }
                });

                obtenirSanctions().then(reponse => {
                    const sanctions = reponse;

                    if (this.estMonte) {
                        this.setState({ sanctions: sanctions, enChargementSanctions: false });
                    }
                });
                if (this.estMonte) {
                    this.setState({ serviceGarde: serviceGarde, enChargementServiceGarde: false });
                }
            }

            else {
                if (this.estMonte) {
                    this.setState({
                        serviceGarde: serviceGarde,
                        enChargementServiceGarde: false,
                        enChargementSanctions: false,
                        enChargementDelai: false,
                        enChargementMenu: false,
                    });
                }

            }

        });

    }

    componentWillUnmount() {
        this.estMonte = false;
    }

    handleClick = (e) => {
        e.preventDefault();
        if (this.estMonte) {
            this.setState({ afficherSantions: !this.state.afficherSantions });
        }
    }

    render() {
        const { enChargementServiceGarde, enChargementMenu, enChargementDelai, enChargementSanctions, serviceGarde, menus } = this.state;
        
        if (enChargementServiceGarde || enChargementMenu || enChargementSanctions || enChargementDelai) {
            return <Chargement />;
        }

        const { erreur } = serviceGarde;
        if (erreur) {
            return <Erreur serviceGarde={serviceGarde} />;
        }

        const { afficherSantions, sanctions, delai } = this.state;
        return (
            <>
                <InformationSG serviceGarde={serviceGarde} afficherSantions={afficherSantions} onClick={this.handleClick} />
                <Menu menus={menus} />
                {!afficherSantions ?
                    <Resultat />
                    :
                    <Sanctions sanctions={sanctions} delai={delai} />
                }
            </>
        );
    }
}
